<template lang="html">
  <footer class="footer">
    <div class="footer-container row-between" :withoutMT="withoutMT">
      <nav class="" v-if="!!links">
        <a v-for="(data, key) in links" :href="data" target="_blank">{{ key }}</a>
        <idioma v-if="brand.languagebydefault"></idioma>
      </nav>
      <div>
        <a v-if="!!copyright" :href="copyright.link" target="_blank">
          {{ computedCopyrightText }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
import idioma from '@/components/parts/idioma';

export default {
  name: 'app-footer',
  computed: {
    ...mapGetters({
      links: 'getFooterLinks',
      brand: 'getBrand',
      copyright: 'getFooterCopyright'
    }),
    computedCopyrightText() {
      if (!this.copyright || !this.copyright.text) return '';
      const year = new Date().getFullYear();
      return this.copyright.text.replace('{year}', year);
    },
    withoutMT: function () {
      let views = [
        '/login',
        '/login/empresas',
        '/login/antiguos',
        '/login/alumnos',
        '/mantenimiento',
        '/acceso',
        '/gma2019',
      ];
      return (views.some(el => el == this.$route.path));
    }
  },
  components: {
    'idioma': idioma
  }
}
</script>


// WEBPACK FOOTER //
// src/components/parts/footer.vue